import React, { Component } from "react";
import {Link, useNavigate, useParams} from "react-router-dom";
import '../../style/generic.css';
import '../../style/heroCategory.css';

import arrowCat from '../../images/frecciaCategorie.png';
import * as Constanti from '../../Utils/constants.js';
import play from '../../images/solar_play-bold.png';
import ReactPlayer from "react-player";
import YoutubeClass from '../youtube/youtube.js';

const isMobile = window.innerWidth < 768;
class heroSectionCategory extends Component{
 constructor(props){
    
    super(props);
   
  this.handleOpenPlayer = this.handleOpenPlayer.bind(this);
  
  };
getYouTubeVideoId(url) {
  const regex =
    /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|v\/|live\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
  const match = url.match(regex);
  return match ? match[1] : null;
}
 
  handleOpenPlayer(){
   
    const videoId = this.getYouTubeVideoId(this.props.link); // Sostituisci con l'ID del video desiderato
    this.props.onShowVideo(videoId); // Chiama la funzione di callback
  // callback al padre
  };

   
 
  render(){
    var urlImg = "";
    if (this.props.img.includes("http")){
    urlImg = this.props.img;
    }else{
      urlImg = Constanti.url_img_new+this.props.img;
    }
    return (
    <>
    <section className={"heroSectionCategory " + (isMobile ? "heightCategory":"")}>
    {!isMobile &&
    <>
    <div className="hero-img">
    {this.props.videoDetail === true &&
    <img src={this.props.img} alt="" className="img-hero"/>
    }
     {(this.props.videoDetail == null || this.props.videoDetail === false) &&
    <img src={urlImg} alt="" className="img-hero"/>
     }
    </div>
      <div className="hero-left"></div>
      <div className="hero-video-info height-100">
      <div className="container textWhite height-100">
      <div className="flex vertical align-start justify-center height-100 headerMobile">
        <div className={"HeroTitle padding-bottom-16 padding-top-32 "+ (this.props.videoDetail ? "categoryDetailNews" : "")} >
          {this.props.titolo}
          </div>
          <div className={"descriptionCat padding-bottom-16 "+(this.props.videoDetail ? "descriptionDetailNews" : "")}>
          {this.props.descrizione}
          </div>
           {(this.props.videoDetail == null || this.props.videoDetail === false) &&
          <div className="buttonHero">
           <a href="/" onClick={e => {let hero = document.getElementById("anchor");
            e.preventDefault();  
            hero && hero.scrollIntoView({ behavior: 'smooth' });
            }}
              >
          <img src={arrowCat}></img>
          </a></div>
           }
          {this.props.videoDetail === true &&
          <div className="buttonHero">
         <button className="buttonVideo flex cursor-pointer" onClick={this.handleOpenPlayer}> Guarda ora <img height={16}  src ={play} alt="guarda ora" className="padding-left-8" ></img></button>
         
         </div>
      
          }
          
         
      </div>
    </div>

      </div>
      </>
}
  { isMobile &&
    <div className="flex vertical">
    <div >
    <div className="hero-img-mobile">
    {this.props.videoDetail === true &&
    <img src={this.props.img} alt="" className="img-hero"/>
    }
     {(this.props.videoDetail == null || this.props.videoDetail === false) &&
    <img src={urlImg} alt="" className="img-hero"/>
     }
    </div>
      <div className="hero-left-mobile"></div>
      </div>
      <div className="hero-video-info height-100">
      <div className="container textWhite height-100">
      <div className="flex vertical align-start height-100 headerMobile">
        <div className={"HeroTitle title-mobile padding-bottom-16 padding-top-32 "+ (this.props.videoDetail ? "categoryDetailNews" : "")} >
          {this.props.titolo}
          </div>
          <div className={"descriptionCat desc-mobile padding-bottom-16 "+(this.props.videoDetail ? "descriptionDetailNews" : "")}>
          {this.props.descrizione}
          </div>
           
          {this.props.videoDetail === true &&
          <div className="buttonHero">
         <button className="buttonVideo flex cursor-pointer" onClick={this.handleOpenPlayer}> Guarda ora <img height={16}  src ={play} alt="guarda ora" className="padding-left-8" ></img></button>
         
         </div>
      
          }
          
         
      </div>
    </div>

      </div>
      </div>
  }
    </section>
</>
    )
}
}

export default heroSectionCategory; 